'use strict';

var SeasonalityPanelConfig = function SeasonalityPanelConfig($stateProvider) {
  $stateProvider.state('app.seasonality', {
    url: '/workflow/seasonality',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER||DYNAMIC_AVAILABILITY;DYNAMIC_AVAILABILITY_SEASONALITY'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-seasonality-panel></rm-seasonality-panel>'
      }
    }
  });
};
module.exports = SeasonalityPanelConfig;
SeasonalityPanelConfig.$inject = ['$stateProvider'];